import React, { useContext, useMemo } from "react";
import {
  ComposedChart as BaseChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { get, has, includes, isEmpty, isNil, isObject } from "lodash";
import { useTheme } from "@material-ui/core";
import { ThemeContext } from "../../core/providers/ThemeContext";
import { ORIENTATION_V, ORIENTATIONS } from "./ChartResolver";

export default function ComposedChart(props) {
  const {
    orientation,
    def,
    color,
    valName,
    showX,
    showY,
    showCartesianGrid,
    showLabelInside,
    labelInsideKey,
    labelInsideColor,
  } = props?.data?.valor || {};

  const { theme } = useContext(ThemeContext);
  const muiTheme = useTheme();
  const layout = includes(ORIENTATIONS, orientation)
    ? orientation
    : ORIENTATION_V;

  const showXCalc = showX === true;
  const showYCalc = showY === true;
  const showCartesianGridCalc = showCartesianGrid === true;

  const colorOfLabelInside = useMemo(() => {
    if (!isNil(labelInsideColor) && !isEmpty(labelInsideColor)) {
      if (isObject(labelInsideColor)) {
        return has(labelInsideColor, theme)
          ? get(labelInsideColor, theme)
          : null;
      } else {
        return labelInsideColor;
      }
    } else {
      return null;
    }
  }, [theme, labelInsideColor]);

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BaseChart layout={layout} data={def}>
        {showCartesianGridCalc && <CartesianGrid stroke="#f5f5f5" />}
        {layout === ORIENTATION_V ? (
          <>
            <XAxis type="number" hide={!showXCalc} />
            <YAxis
              type="category"
              scale="band"
              hide={!showYCalc}
              dataKey="label"
            />
          </>
        ) : (
          <>
            <XAxis
              type="category"
              scale="band"
              dataKey="label"
              hide={!showXCalc}
            />
            <YAxis type="number" hide={!showYCalc} />
          </>
        )}

        <Tooltip
          contentStyle={{
            color: muiTheme.palette.text.primary,
            backgroundColor: muiTheme.palette.background.paper,
          }}
        />
        <Bar dataKey="val" name={valName} fill={color || "#413ea0"}>
          {showLabelInside && (
            <LabelList
              dataKey={labelInsideKey || "label"}
              position="insideLeft"
              fill={colorOfLabelInside}
            />
          )}
        </Bar>
      </BaseChart>
    </ResponsiveContainer>
  );
}
